import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import '../styles/HomePage.css';
import NewsTicker from "../components/NewsBarPage";

// Hero images
import bg1 from "../assets/bg/bg1.jpg";
import bg2 from "../assets/bg/bg2.jpg";
import bg3 from "../assets/bg/bg3.jpg";
import bg4 from "../assets/bg/bg4.jpg";
import bg5 from "../assets/bg/bg5.jpg";
import bg6 from "../assets/bg/bg6.jpg";
import bg7 from "../assets/bg/bg7.jpg";
import bg8 from "../assets/bg/bg8.jpg";
import bg9 from "../assets/bg/bg9.jpg";
import bg10 from "../assets/bg/bg10.jpg";
import bg11 from "../assets/bg/bg11.jpg";
import bg12 from "../assets/bg/bg12.jpg";
import bg13 from "../assets/bg/bg13.jpg";
import bg14 from "../assets/bg/bg14.jpg";
import bg15 from "../assets/bg/bg15.jpg";
import bg16 from "../assets/bg/bg16.jpg";

// Sectors images
import ecommerceImg from "../assets/sectors/ecommerce.jpg";
import academyImg from "../assets/sectors/academy.jpg";
import consultancyImg from "../assets/sectors/consultancy.jpg";
import economyImg from "../assets/sectors/economy.jpg";
import industryImg from "../assets/sectors/industry.jpg";
import constructionImg from "../assets/sectors/construction.jpg";
import technologyImg from "../assets/sectors/technology.jpg";
import servicesImg from "../assets/sectors/services.jpg";
import charityImg from "../assets/sectors/charity.jpg";

// Main activities images
import managementImg from "../assets/sectors/management/management.jpg";
import engineeringImg from "../assets/sectors/engineering/engineering.jpg";
import procurementImg from "../assets/sectors/procurement/procurement.jpg";
import constructionActivityImg from "../assets/sectors/construction/construction.jpg";

// Announcements images
import announcement1 from "../assets/Announcements/A1.jpg";
import announcement2 from "../assets/Announcements/A2.jpg";
import announcement3 from "../assets/Announcements/A3.jpg";
import announcement4 from "../assets/Announcements/A4.jpg";

// Feedback images
import kingPhoto from "../assets/feedback/kingPhoto.jpg";
import ahmadPhoto from "../assets/feedback/ahmadPhoto.jpg";
import aliPhoto from "../assets/feedback/aliPhoto.jpg";
import huseyinPhoto from "../assets/feedback/huseyinPhoto.jpg";

// Other images
import aboutusImg from '../assets/aboutus.jpg';
import diagramImg from "../assets/ADAM HOLDING UNION.png";
import worldMapImg from "../assets/world-map.jpg";

const homepageData = {
  testimonials: [
    {
      text: "I have dealt with many companies around the world, and when I met Dr. Muhammad Haidar in the Arabian Gulf region—Dubai—and worked with his company, Adam Holding Union, I realized the immense experience they possess...",
      name: "King Zofoa Abubaka",
      title: "King of Babungo",
      photo: kingPhoto
    },
    {
      text: "Delve deeper into Adam Holding Union's mission, values and culture. By researching these elements, you can identify the core principles that guide Adam Holding Union's operations...",
      name: "Ahmad Slaih",
      title: "CEO at Trust",
      photo: ahmadPhoto
    },
    {
      text: "I learned from Adam Holding Union what it means to succeed in project execution. They are the pioneers of Six Sigma in the region...",
      name: "Hüseyin Arvas",
      title: "CEO at Itimat Company",
      photo: huseyinPhoto
    },
    {
      text: "Through many successful joint projects and businesses that my company has implemented with Adam Holding Union in the fields of solar energy, construction, infrastructure...",
      name: "Ali Aydın",
      title: "Kuveyt Turk Bank Manager",
      photo: aliPhoto
    }
  ],
  
  announcements: [
    {
      id: 1,
      category: "Event",
      title: "Announcing the nomination opportunities for membership in the Board of Directors of Adam Holding Union.",
      description: "On February 22, 2025, the founding body of Adam Holding Union announced the opening of nominations for membership in the Board of Directors of Adam Holding Union.",
      date: "Feb 22, 2025",
      image: announcement1
    },
    {
      id: 2,
      category: "Event",
      title: "Adam Charity Foundation Iftar",
      description: "Adam Charity Foundation participates in the Iftar project in Mali, Africa.",
      date: "Mar 3, 2025",
      image: announcement2
    },
    {
      id: 3,
      category: "Event",
      title: "Adam Holding Union 2025 Annual Meeting",
      description: "On January 26, 2023. The founding body of Adam Holding Union met with Adam representatives and partners from Africa.",
      date: "Jan 26, 2025",
      image: announcement3
    },
    {
      id: 4,
      category: "Event",
      title: "A warm welcome for His Majesty the King of Papango in Istanbul",
      description: "On June 19, 2024, the Chairman of the Board of Directors of Adam Holding Union receives His Majesty King Babongo...",
      date: "Jun 19, 2024",
      image: announcement4
    },
  ],
  
  sectors: [
    { id: "ecommerce", name: "Adam Commerce", subName: "ADAM STORE", image: ecommerceImg },
    { id: "academy", name: "Adam Education", subName: "ADAM INTERNATIONAL ACADEMY", image: academyImg },
    { id: "consultancy", name: "Adam Consultancy", subName: "ADAM SOLUTIONS", image: consultancyImg },
    { id: "economy", name: "Adam Economy", subName: "ADAM BANK", image: economyImg },
    { id: "industry", name: "Adam Industry", subName: "ADAM INDUSTRIES", image: industryImg },
    { id: "construction", name: "Adam Construction", subName: "ADAM EPCM", image: constructionImg },
    { id: "technology", name: "Adam Technology", subName: "ADAM INNOVATION", image: technologyImg },
    { id: "services", name: "Adam Services", subName: "ADAM ALLIANCE", image: servicesImg },
    { id: "charity", name: "Adam Charity", subName: "ADAM FOUNDATION", image: charityImg },
  ],
  
  activities: [
    {
      id: "engineering",
      title: "Engineering",
      image: engineeringImg,
      description: "A discipline dedicated to problem solving. Adam built environment and infrastructure, the devices we use to communicate..."
    },
    {
      id: "procurement",
      title: "Procurement",
      image: procurementImg,
      description: "Involves every activity involved in obtaining the goods and services Adam needs to support its daily operations..."
    },
    {
      id: "construction",
      title: "Construction",
      image: constructionActivityImg,
      description: "Covers the processes involved in delivering buildings, infrastructure, industrial facilities and associated activities..."
    },
    {
      id: "management",
      title: "Management",
      image: managementImg,
      description: "Adam organize and direct workflow, operations, and employees to meet Adam goals..."
    }
  ],

  globalPresence: {
    title: "Our Global Footprint",
    subtitle: "Strategically located across 4 continents to serve you better",
    stats: [
      { label: "Countries", value: "20+" },
      { label: "Offices", value: "15" },
      { label: "Projects", value: "200+" },
      { label: "Partners", value: "700+" }
    ]
  }
};

const HomePage = () => {
  const heroSlides = [
    { text: " ", text2: "", image: bg1 },
    { text: "The Game changers", text2: "ADAM COMMERCE", image: bg15 },
    { text: "Creating Glority... in a Complex Reality", text2: "ADAM EDUCATION", image: bg2 },
    { text: " ", text2: "ADAM CONSULTANCY", image: bg3 },
    { text: "ADAM is the Solution - minded and Perfection driven", text2: "ADAM ECONOMY", image: bg4 },
    { text: " ", text2: "ADAM INDUSTRY", image: bg5 },
    { text: " ", text2: "ADAM CONSTRUCTION", image: bg6 },
    { text: "Bridging the gaps, making the difference, changing the game", text2: "ADAM TECHNOLOGY", image: bg7 },
    { text: " ", text2: "ADAM SERVICES", image: bg8 },
    { text: "The Game changers", text2: "ADAM CHARITY", image: bg9 },
    { text: "The Game changers", text2: "", image: bg10 },
    { text: "The Game changers", text2: "", image: bg11 },
    { text: "Creating Glority... in a Complex Reality", text2: "", image: bg12 },
    { text: "The Game changers", text2: "", image: bg13 },
    { text: "The Game changers", text2: "", image: bg14 },
    { text: "The Game changers", text2: "", image: bg16 },
  ];

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentSlideIndex((prev) => (prev + 1) % heroSlides.length);
        setIsFading(false);
      }, 1000);
    }, 3000);

    return () => clearInterval(interval);
  }, [heroSlides.length]);

  return (
    <div className="homepage">
      <header className="homepage-hero">
        <div className="homepage-hero-background">
          {heroSlides.map((slide, index) => (
            <div
              key={`slide-${index}`}
              className={`homepage-hero-slide ${index === currentSlideIndex ? "homepage-hero-slide--active" : ""}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            />
          ))}
        </div>
        <div className="homepage-hero-content">
          <h1 className="homepage-hero-title">ADAM HOLDING UNION</h1>
          <p className="homepage-hero-subtitle">{heroSlides[currentSlideIndex].text2}</p>
          <p className="homepage-hero-text">{heroSlides[currentSlideIndex].text}</p>
        </div>
      </header>
      
      <div className="homepage-newsticker-container">
        <NewsTicker />
      </div>

      <section className="homepage-section homepage-map">
        <h2 className="homepage-section-title">Adam Holding Union Locations (ADAM Map)</h2>
        <div className="homepage-map-container">
          <div className="homepage-map-wrapper">
            <img src={worldMapImg} alt="Adam Holding Global Presence" className="homepage-map-image" />
            <div className="homepage-map-overlay">
              <div className="homepage-map-overlay-content">
                <h2 className="homepage-map-title">{homepageData.globalPresence.title}</h2>
                <p className="homepage-map-subtitle">{homepageData.globalPresence.subtitle}</p>
                <div className="homepage-map-stats">
                  {homepageData.globalPresence.stats.map((stat, index) => (
                    <div key={index} className="homepage-map-stat">
                      <span className="homepage-map-stat-value">{stat.value}</span>
                      <span className="homepage-map-stat-label">{stat.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="homepage-section homepage-about">
        <div className="homepage-about-container">
          <div className="homepage-about-image">
            <img src={aboutusImg} alt="About Adam Holding Union" />
          </div>
          <div className="homepage-about-content">
            <h2 className="homepage-section-title">About Us</h2>
            <p>Adam Holding Union is a global associate group of companies and a leading corporate and entrepreneurial services firm...</p>
            <p>We support communities, organizations, companies, and individuals in various fields, including education, engineering, consulting, economy...</p>
            <p>As trusted advisors, certified consultants, and professional managers, we are solution-driven, business-oriented experts...</p>
            <a href="./about" className="homepage-btn homepage-btn--primary">More About ADAM</a>
          </div>
        </div>
      </section>

      <section className="homepage-section homepage-announcements">
        <h2 className="homepage-section-title">Adam Announcements</h2>
        <div className="homepage-announcements-grid">
          {homepageData.announcements.map((announcement) => (
            <article key={announcement.id} className="homepage-announcement-card">
              <div className="homepage-announcement-image">
                <img src={announcement.image} alt={announcement.title} />
                <div className="homepage-announcement-date">{announcement.date}</div>
              </div>
              <div className="homepage-announcement-content">
                <h3>{announcement.title}</h3>
                <p>{announcement.description}</p>
              </div>
            </article>
          ))}
        </div>
        <a href="./announcements" className="homepage-btn homepage-btn--secondary">View All Announcements</a>
      </section>

      <section className="homepage-section homepage-activities">
        <h2 className="homepage-section-title">Adam EPCM (Main Activities)</h2>
        <div className="homepage-activities-grid">
          {homepageData.activities.map((activity) => (
            <div key={activity.id} className="homepage-activity-card">
              <img src={activity.image} alt={activity.title} className="homepage-activity-image" />
              <h3>{activity.title}</h3>
              <p>{activity.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="homepage-section homepage-sectors">
        <h2 className="homepage-section-title">ADAM (9 X 9) Sectors</h2>
        
        <div className="homepage-sectors-diagram-container">
          <div className="homepage-sectors-diagram-wrapper">
            <img src={diagramImg} alt="Adam Holding Sectors Diagram" className="homepage-sectors-diagram-main" />
            <div className="homepage-sectors-diagram-overlay">
              <img src={diagramImg} alt="Adam Holding Sectors Diagram Overlay" className="homepage-sectors-diagram-overlay-image" />
              <div className="homepage-sectors-diagram-content">
                <h3>9 Integrated Sectors</h3>
                <p>Working in harmony to deliver comprehensive business solutions worldwide</p>
              </div>
            </div>
          </div>
        </div>

        <div className="homepage-sectors-grid-container">
          <div className="homepage-sectors-grid-three-columns">
            {homepageData.sectors.map((sector) => (
              <Link to={`/sector/${sector.id}`} key={sector.id} className="homepage-sector-card-three">
                <div className="homepage-sector-card-image-container">
                  <img src={sector.image} alt={sector.name} className="homepage-sector-card-image" />
                  <div className="homepage-sector-card-overlay">
                    <span className="homepage-sector-card-explore">Explore →</span>
                  </div>
                </div>
                <div className="homepage-sector-card-content">
                  <h3>{sector.name}</h3>
                  <p className="homepage-sector-card-subname">{sector.subName}</p>
                  <div className="homepage-sector-card-line"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="homepage-section homepage-testimonials">
        <h2 className="homepage-section-title">Customer Feedback</h2>
        <div className="homepage-testimonials-grid">
          {homepageData.testimonials.map((testimonial, index) => (
            <div key={index} className="homepage-testimonial-card">
              <p className="homepage-testimonial-text">"{testimonial.text}"</p>
              <div className="homepage-testimonial-author">
                <img src={testimonial.photo} alt={testimonial.name} className="homepage-testimonial-photo" />
                <div className="homepage-testimonial-info">
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HomePage;